import script from "./SignInDonePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInDonePage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInDonePage.vue?vue&type=style&index=0&id=76f23e94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f23e94"]])

export default __exports__